import {
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  VerticalAlignTopOutlined
} from '@ant-design/icons';
import { Button, Flex } from 'antd';
import type { Key } from 'react';

import { showConfirmModal } from '@/components/ConfirmModal';
import { BULK_OPERATION_TYPES } from '@/pages/FieldAllocation/hooks/useGetBulkOperations/constants';

import type { BulkOperationOption } from '../../types';
import { DEFAULT_BUTTON_TEXTS } from '../RowSelectionMenuButton/constants';

import {
  DEFAULT_CANCEL_TEXT,
  DEFAULT_CONFIRM_DESCRIPTION,
  DEFAULT_CONFIRM_TITLE
} from './constants';
import * as Styled from './styles';

const DEFAULT_BUTTON_ICONS: Record<string, React.ReactNode> = {
  edit: <EditOutlined />,
  discard: <DeleteOutlined />,
  publish: <VerticalAlignTopOutlined />
};

type Props = {
  selectedKeys: Key[];
  selectedBulkOperation: BulkOperationOption;
  onCancelAndClear?: () => void;
};

export const BulkOperationFooter = ({
  selectedKeys,
  selectedBulkOperation,
  onCancelAndClear
}: Props) => {
  const handleActionButtonClick = () => {
    if (selectedBulkOperation.showConfirmModal) {
      showConfirmModal({
        title: selectedBulkOperation.confirmTitle || DEFAULT_CONFIRM_TITLE,
        content:
          selectedBulkOperation.confirmDescription ||
          DEFAULT_CONFIRM_DESCRIPTION,
        okText: selectedBulkOperation.confirmOkButtonText,
        cancelText: selectedBulkOperation.confirmCancelButtonText,
        icon: selectedBulkOperation.confirmIcon,
        onOk: () => {
          selectedBulkOperation.onConfirm();
        }
      });

      return;
    }
    selectedBulkOperation.onConfirm();
  };

  return (
    <Flex justify='space-between' align='center' gap={24}>
      <Flex gap={4} align='center'>
        <Styled.SelectedItemsText>
          {selectedKeys.length}
        </Styled.SelectedItemsText>
        <Styled.SelectedItemsText>
          {selectedKeys.length === 1 ? 'item' : 'items'} selected
        </Styled.SelectedItemsText>
      </Flex>
      <Flex gap={8}>
        <Button
          icon={<CloseOutlined />}
          disabled={selectedBulkOperation.loading}
          onClick={onCancelAndClear}>
          {DEFAULT_CANCEL_TEXT}
        </Button>

        <Button
          type='primary'
          variant='solid'
          loading={selectedBulkOperation.loading}
          disabled={
            selectedBulkOperation.disabled ||
            selectedBulkOperation.loading ||
            selectedKeys.length === 0
          }
          danger={selectedBulkOperation.type === BULK_OPERATION_TYPES.DISCARD}
          color={
            selectedBulkOperation.type === BULK_OPERATION_TYPES.PUBLISH
              ? 'blue'
              : undefined
          }
          icon={
            selectedBulkOperation.buttonIcon ||
            DEFAULT_BUTTON_ICONS[selectedBulkOperation.type] ||
            undefined
          }
          onClick={handleActionButtonClick}>
          {selectedBulkOperation.footerButtonText ||
            selectedBulkOperation.buttonText ||
            DEFAULT_BUTTON_TEXTS[
              selectedBulkOperation.type as keyof typeof DEFAULT_BUTTON_TEXTS
            ] ||
            ''}
        </Button>
      </Flex>
    </Flex>
  );
};
